// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__4JG4g","title":"AfterImages45_title__1kJj2","images":"AfterImages45_images__2lq8b"};